import { ReactElement, useCallback } from "react";
import { RowSelectedEvent, GridReadyEvent } from "ag-grid-community";
import { AgGrid } from "@jsq/ds/core";
import { ComplianceTable } from "~/pages/Compliance/ComplianceTable";

type SelectedCountPanel = {
  setValue: (value: string) => void;
  setDisplayed: (displayed: boolean) => void;
};

interface ComplianceTableContainerProps {
  setGridApiv2: (api: AgGrid.GridApi) => void;
  setShowCreateNewCaseButtonv2: (show: boolean) => void;
}

export const ComplianceTableContainer = ({
  setGridApiv2,
  setShowCreateNewCaseButtonv2,
}: ComplianceTableContainerProps): ReactElement => {
  const handleRowSelectionChanged = useCallback(
    (event: RowSelectedEvent) => {
      const selectionState =
        event.api.getServerSideSelectionState() as AgGrid.IServerSideSelectionState;
      const idsAreSelectedVsUnselected: boolean = !selectionState.selectAll;
      const toggledNodeCount: number = selectionState.toggledNodes.length;
      const selectedRowCount: number = idsAreSelectedVsUnselected
        ? toggledNodeCount
        : event.api.paginationGetRowCount() - toggledNodeCount;
      const panelCandidate = event.api.getStatusPanel("agSelectedRowCountComponent");
      const panel = panelCandidate as SelectedCountPanel | null;
      panel?.setValue(selectedRowCount.toString());
      panel?.setDisplayed(selectedRowCount !== 0);
      setShowCreateNewCaseButtonv2(selectedRowCount === 0);
    },
    [setShowCreateNewCaseButtonv2],
  );
  const handleOnGridReady = useCallback(
    (event: GridReadyEvent) => {
      setGridApiv2(event.api);
    },
    [setGridApiv2],
  );
  return (
    <ComplianceTable
      handleRowSelectionChanged={handleRowSelectionChanged}
      handleOnGridReady={handleOnGridReady}
    />
  );
};
